<template>
  <!--Start Footer Area-->
  <div class="footer-area pt-100 pb-70">
    <div class="container">
      <div class="row">
        <div class="col-lg-4 col-sm-6">
          <div class="footer-logo-area">
            <a href="#"
              ><img src="/vf/images/logo/footer_logo.png" alt="Image"
            /></a>
            <p>
              Vedanta P.G Girls College, Ringus <br />is a Not-For-Profit
              institution, empowering women.
            </p>
            <div class="contact-list">
              <ul>
                <li><h5 style="color:white">Contact</h5></li>
                <li><a href="tel:919785371692 ">9785371692</a></li>
                <li>
                  <a href="mailto:principal.vpggc@vedantafoundation.org">
                    principal.vpggc@vedantafoundation.org</a
                  >
                </li>
                <li>
                  <router-link to="/admissioncommittee"
                    >Opening Hours: 08:30 am - 04:30 pm (Mon - Sat)</router-link
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-sm-6">
          <div class="footer-widjet">
            <h3>Committee</h3>
            <div class="list">
              <ul>
                <li>
                  <router-link to="/admissioncommittee"
                    >Admission Committee</router-link
                  >
                </li>
                <li>
                  <router-link to="/wdc"
                    >Women Development Committee</router-link
                  >
                </li>
              </ul>
            </div>

            <h3 style="margin-top: 30px">Other Colleges</h3>
            <div class="list">
              <ul>
                <li>
                  <a href="https://vedantavc.ac.in"
                    >Vedanta College, Vithalwadi</a
                  >
                </li>
                <li>
                  <a href="https://vedantakc.edu.in"
                    >Vedanta College, Kolkata</a
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-sm-6">
          <div class="footer-widjet">
            <h3>Student Corner</h3>
            <div class="list">
              <ul>
                <li><a href="https://rdc.eshala.co.in/events">Events</a></li>
                <li><a href="https://rdc.eshala.co.in/page/news">News</a></li>
                <li>
                  <a href="https://rdc.eshala.co.in/page/notices">Notices</a>
                </li>
                <li>
                  <a href="https://rdc.eshala.co.in/welcome/library_books"
                    >Library</a
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-lg-2 col-sm-6">
          <div class="footer-widjet">
            <h3>Other Links</h3>
            <div class="list">
              <ul>
                <li><router-link to="/contact">Contact</router-link></li>
                <li><router-link to="/eResources">eResources</router-link></li>
                <li>
                  <router-link to="/affiliation">Affiliation</router-link>
                </li>
                <li>
                  <router-link to="/programoffered"
                    >Program Offered</router-link
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="shape">
        <img src="/images/shape-1.png" alt="Image" />
      </div>
    </div>
  </div>
  <!--End Footer Area-->

  <!--Start Copyright Area-->
  <div class="copyright-area">
    <div class="container">
      <div class="copyright">
        <div class="row">
          <div class="col-lg-6 col-md-4">
            <div class="social-content">
              <ul>
                <li><span>Follow Us On</span></li>
                <li>
                  <a
                    href="https://www.facebook.com/womencollegereengus?mibextid=ZbWKwL"
                    target="_blank"
                    ><i class="ri-facebook-line"></i
                  ></a>
                </li>
                <li>
                  <a
                    href="https://www.instagram.com/vedantacollegereengus?igsh=ZjRrbmF2ajNlZWFu"
                    target="_blank"
                    ><i class="ri-instagram-line"></i
                  ></a>
                </li>
                <li>
                  <a
                    href="https://www.linkedin.com/in/vedanta-p-g-girls-college-r-33a4a6253?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
                    target="_blank"
                    ><i class="ri-linkedin-line"></i
                  ></a>
                </li>
                <li>
                  <a
                    href="https://youtube.com/@vedantapggirlscollegereeng9330?si=MgxBLE2ibuybHhR4"
                    target="_blank"
                    ><i class="ri-youtube-line"></i
                  ></a>
                </li>
                <li>
                  <a
                    href="https://wa.me/919785371692?text=Welcome%20to%20Vedanta%20PG%20Girls%20College,%20Reengus.%20%0AHow%20can%20I%20assist%20you%20today%20?"
                    target="_blank"
                    ><i class="ri-whatsapp-line"></i
                  ></a>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-lg-6 col-md-8">
            <div class="copy">
              <p>
                © Vedanta P.G. Girls College, Reengus is Proudly Owned by
                <a href="https://vedantafoundation.org" target="_blank"
                  >Vedanta Foundation</a
                >
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--End Copyright Area-->

  <!-- Start Go Top Area -->
  <a href="https://rdc.eshala.co.in/page/enquiry" style="display: none">
    <button class="enquiryNow btn btn-primary btn-lg">
      <i class="fas fa-arrow-alt-circle-right"></i> Enquire Now
    </button>
  </a>
  <!-- End Go Top Area -->
</template>

<script>
export default {
  name: "AppFooter",
};
</script>

<style>
.enquiryNow {
  position: fixed;
  cursor: pointer;
  top: 50%;
  background-color: #73bf43;
  z-index: 5;
  text-align: center;
  border-radius: 0;
  border: 0;
}
</style>
